<div id="dropdownWrapper"
     class="pr-6">
  <p>Radius</p>
  <mat-form-field appearance="fill" class="headerCellInput">
    <mat-select [formControl]="radius.formControl" panelClass="ccDropdownPanels">
      @for (val of radius.radiusValues; track val) {
        <mat-option [value]="val">
          {{ val | formatDistance }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
